<template>
  <side-bar-page>
    <template slot="content">
    <div class="content content-m messages-page">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-4 col-md-5 mobile-container" id="first" v-show="!isMobileResolution || !isDialogOpened">
                <div class="card card-profile">
                    <div class="card-header msg-card-header" @click="switchSearchResults()">
                          <h4 class="title title-header msg-header">{{$t('msg_select')}} 
                          </h4>
                          <i class="fa fa-angle-up" v-if="showSearchResults"></i> 
                          <i class="fa fa-angle-down" v-if="!showSearchResults"></i> 
                    </div>
                    
                    <b-collapse id="search-result-collapse" class="card-body select-body" v-model="showSearchResults">
                        <div class="form-group has-label input-group search-input">
                            <input type="text" class="form-control" :placeholder="$t('s_filters_name')" @keydown.enter="applyFilters()" v-model="searchFilter.name">
                            <button class="btn btn-default btn-search" @click="applyFilters()">{{$t('search')}}</button>
                        </div>

                        <div class="search-result-box" @scroll="onScrollUsersList">
                          <sync-loader v-if="isSearching" class="sync-loader text-center" color="#a82d38"></sync-loader>
                          <p class="msg-no-find" v-if="(!users || users.length < 1) && !isSearching">{{$t('noFind')}}</p>
                          <div v-for="user in users" :key="user.id">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="search-result media" @click="startDialog(user)">
                                  <div class="d-flex mr-3 align-self-top">
                                    <a class="profile-link" :href="'/profile/' + user.id" target="_blank">
                                      <img :src="user.avatar" class="img-avatar"/>
                                    </a>
                                  </div>
                                  <div class="media-body">
                                    <div v-if="user.userCategory==='artist'">
                                      <a><span>{{user.firstName}} {{user.lastName}}</span></a>
                                      <p class="artist-type">{{$t('artist')}}</p>
                                    </div>
                                    <div v-if="user.userCategory==='agent'">
                                      <a><span>{{user.firstName}} {{user.lastName}}</span></a>
                                      <p class="artist-type">{{$t('pr_m_agent')}}</p>
                                    </div>
                                    <div v-if="user.userCategory==='employer'">
                                      <a><span>{{user.firstName}} {{user.lastName}}</span></a>
                                      <p class="artist-type">{{$t('pr_m_employer')}}</p>
                                    </div>
                                    <div v-if="user.userCategory==='team'">
                                      <a><span>{{user.teamName}} ({{user.numberOfPersons}} {{$t('s_persons')}})</span></a>
                                      <p class="artist-type">{{$t('team')}}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                    </b-collapse>
                </div>


                <div class="card dialog-list"><div class="card-header"><h2>Messages</h2></div><div class="card-body">
                  <div v-if="isDialogGetList || !isDialogGetListFinished" role="status">Loading…</div>
                  <p v-else-if="!dialogs.length">{{$t('msg_no_dialogs')}}</p>
                  <div v-for="(dialog, dialogIndex) in dialogs" :key="dialog.id">
                        <div class="msg-box" :class="{'selected-dialog': dialog.showDialog}">
                            <div class="row">
                                <div class="msg-img padding-15">
                                    <img :src="dialog.avatar" class="image-avatar"/>
                                </div>
                                <div class="msg-title-block" @click="showDialog(dialogIndex)">
                                    <span class="msg-title">{{dialog.person}}
                                        
                                    </span>
                                    <div class="msg-old">
                                        {{dialog.lastMessage}}
                                    </div>
                                </div>
                                <span class="msg-delete" @click="deleteDialog(dialogIndex)">
                                    <i class="fa fa-times"></i>
                                </span>
                            </div>
                        </div>
                  </div>
                </div></div>
            </div>

            <div class="col-lg-8 col-md-7 mobile-container" id="second" v-show="!isMobileResolution || isDialogOpened">
                <div class="card">
                    <span v-if="!isMobileResolution">
                      <div class="card-header msg-card-header">
                            <h4 class="title title-header msg-header">{{$t('msg_header_title')}}</h4>
                      </div>
                    </span>

                    <span v-if="isMobileResolution">
                      <div class="card-header msg-card-header" v-if="!isDialogOpened">
                            <h4 class="title title-header msg-header">{{$t('msg_header_title')}}</h4>
                      </div>
                    </span>

                    <div class="card-body msg-body" :class="{ 'msg-body-mobile': isMobileResolution && isDialogOpened  }" id="dialogsContainer">
                      <sync-loader v-if="isDialogGetList || !isDialogGetListFinished" class="sync-loader text-center" color="#a82d38"></sync-loader>
                      <div v-if="!isDialogOpened" class="msg-no-dialogs">Select a conversation to read and send messages.</div>
                      <span v-for="(dialog, dialogIndex) in dialogs" :key="dialog.id">
                        <b-collapse :id="'msg-' + dialog.id" class="chat-box" v-model="dialog.showDialog">
                              <div class="chat-header">
                                <div class="row">
                                  <div class="col-md-4 col-5 disable-col-padding-r">
                                    <button type="button" class="btn-transparent back" @click="closeDialog(dialogIndex)">
                                      <i class="fa fa-angle-left"></i>{{$t('msg_chat_back')}}
                                    </button>
                                  </div>
                                  <div class="col-md-7 col-5 disable-col-padding">
                                    <a target="_blank" class="person" :href="'/profile/' + dialog.personId">
                                      <i class="fa fa-circle-o" v-if="!isPersonOnline"></i> <i class="fa fa-circle" v-if="isPersonOnline"></i> {{dialog.person}} 
                                    </a>
                                  </div>
                                  <div class="col-md-1 col-2 disable-col-padding">
                                      <b-dropdown size="lg"  variant="link" toggle-class="text-decoration-none" no-caret>
                                        <template slot="button-content"><i class="fa fa-ellipsis-v"></i><span class="sr-only">Menu</span></template>
                                        <b-dropdown-item @click="deleteDialog(dialogIndex)">{{$t('msg_del_dialog')}}</b-dropdown-item>
                                        <!-- <b-dropdown-item @click="addToBlackList(dialogIndex)">{{$t('msg_block_dialog')}}</b-dropdown-item> -->
                                      </b-dropdown>
                                  </div>
                                </div>
                              </div>
                              <div class="chat-body" :id="dialog.showDialog ? 'chatBlock' : null">
                                <span v-for="(msg, msgIndex) in dialog.history" :key="msgIndex">
                                  <span class="chat-person" v-if="!msg.writtenByMe">
                                    <div class="author-name">{{dialog.person}}</div>
                                    {{msg.text}}
                                  </span>
                                  <span class="chat-author" v-if="msg.writtenByMe">
                                    <div class="author-name">{{$t('msg_chat_you')}}</div>
                                    {{msg.text}}
                                  </span>
                                </span>
                              </div>
                              <div class="chat-textarea">
                                  <textarea placeholder="Write a message…" aria-label="Message" v-model="dialog.newMessage" @keyup.ctrl.enter="socketSendMessage(dialog)"></textarea>
                                  <button type="button" class="btn-send" aria-label="Send message" @click="socketSendMessage(dialog)"><i class="fa fa-angle-double-right" aria-hidden="true"></i></button>
                              </div>
                        </b-collapse>
                      </span>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
    </template>
  </side-bar-page>
</template>

<script>
  import Props from '../components/Props';
  import SideBarPage from '../components/SideBarPage';
  import { mapActions, mapGetters, mapState} from 'vuex';
  import { USER_LOAD, USER_SEND, USER_DELETE, AUTH_LOGOUT, USER_IMG_SEND } from "../store/actions/userConst";
  import { GOOGLE_GET_PLACE } from "../store/actions/langConst";
  import {USER_SEARCH, USER_AVATAR_LOAD} from "../store/actions/userConst";
  import {DIALOG_ADD, DIALOG_DELETE, DIALOG_GET_LIST, MESSAGE_ADD, MESSAGE_GET_HISTORY} from "../store/actions/messageConst";
  // import selectSkills from "../components/SelectSkills";
  import syncLoader from 'vue-spinner/src/PulseLoader.vue';
  import swal from 'sweetalert2';
  import datepicker from 'vuejs-datepicker';
  import { interval } from 'rxjs'
  import { takeUntil, filter } from 'rxjs/operators'

  var moment = require('moment');
  moment().format();

  export default {
    // components: { SideBarPage, syncLoader, selectSkills, datepicker, Props },
    components: { SideBarPage, syncLoader, datepicker, Props },
    sockets: {
      connect() {
        console.log('Client IO Connected');
      }
    },
    watch: {
      getMessages() {
        setTimeout(() => {
          var dialog = this.dialogs.find((d) => {
            return d.showDialog === true;
          });
          if (dialog && (typeof dialog !== 'undefined')) {
            dialog.history.push({
              writtenByMe: this.getMessages[this.getMessages.length-1].originalId === this.me.id ? true : false, 
              text: this.getMessages[this.getMessages.length-1].text,
            });
            dialog.lastMessage = this.getMessages[this.getMessages.length-1].text;
            setTimeout(() => {
              var container = this.$el.querySelector("#chatBlock");
              container.scrollTop = container.scrollHeight;
            }, 300);
          }
        });
      },
      getStatus() {
        setTimeout(()=> {
          if (this.getStatus.id !== this.dialogUser.id) {
            this.isPersonOnline = this.getStatus.status;
            console.log('isPersonOnline', this.isPersonOnline);
          }
          // console.log('getStatus ', this.getStatus.id + ' ' + this.getStatus.status);
        })
      },
    },
    beforeDestroy() {
      this.RxLngPointer.unsubscribe();
    },
    mounted() {
      this.RxLngPointer = this.RxLng.subscribe(()=>{});
    },
    created() {
      const obs = interval(100)
      obs
        .pipe(takeUntil(obs.pipe(filter(val => {
          if (this.getUserProfile.id) {
            this.me = JSON.parse(JSON.stringify(this.getUserProfile));
            return true;
          } else {
            if(val>300) {
              console.log('time out 30s. for load profile')
              return true;
            }
          }
        }))))
        .subscribe(()=>{});
        this.applyFilters();
        if (this.isMobileResolution) {
          this.showSearchResults = false;
        }
        this.isDialogGetListFinished = false;
        this.DIALOG_GET_LIST()
        .then(res=> {
          const obs = interval(100)
          obs.pipe(takeUntil(obs.pipe(filter(val => {
            if (this.getUserProfile.id) {
              this.me = JSON.parse(JSON.stringify(this.getUserProfile));
              res.result.forEach(d => {
                this.dialogs.push({
                  id: d.id,
                  showDialog: false, 
                  lastMessage: d.lastMessage,
                  person: d.interlocutor,
                  newMessage: '',
                  personId: this.me.id === d.dialogWithId ? d.ownerId :d.dialogWithId,
                  history: []
                });
              });
              this.isDialogGetListFinished = true;
              this.loadDialogAvatar(this.dialogs);
              return true;
            } else {
              if (val > 300) {
                console.log('time out 30s. for load profile')
                return true;
              }
            }
          })))).subscribe(()=>{});
        }).catch(err=> {
          console.log(err);
          this.toast.fire({
              title: '<i class="fa fa-times fa-2x"></i>' + this.$t('hpf_err_unknown')
          });
        });
    },
    data() {
      return {
        // skills: [],
        // artistTypes: [],
        selectArtistType: null,
        selectArtistCategories: null,
        selectArtistSkill: null,
        isChangedProfile: false,
        RxLngPointer: null,
        modalProps: false,
        user: {
            firstName: '',
            lastName: '',
            city: '',
            country: '',
            phone1: '',
            email: '',
            nickName: '',
            teamName: '',
            numberOfPersons: '',
            aboutMe: '',
            artistTypesList: [],
            userType: 'artist',
            userCategory: '',
        },
        toast: swal.mixin({
                toast: true,
                position: 'bottom-start',
                customClass: 'sweet-modal',
                showConfirmButton: false,
                timer: 5000
        }),
        checkPass: {},
        message: [{showDialog: false}, {showDialog: false}],
        isDialogOpened: false,
        searchFilter: {},
        users: [],
        cacheAvatars: [],
        cacheAvatars2: [],
        currentPage: 1,
        allSearchCount: 0,
        maxPage: 1,
        selectUserType: null,
        queryArr: [],
        showPropsFilter: false,
        showSearchResults: false,
        dialogs: [],
        dialogUser: {},
        isDialogGetListFinished: false,
        isPersonOnline: false
      }
    },
    computed: {
      ...mapGetters(['currentLng', 'getUserProfile', 'isMessageGetHistory', 'isDialogGetList', 'RxLng', 'getAccessToken','isSearching', 'countPerPageS', 'isMobileResolution', 'getMessages', 'getStatus']),
      ...mapState(["messages"]), //"user", 
    },
    methods: {
      ...mapActions([USER_LOAD, USER_SEND, USER_DELETE, AUTH_LOGOUT,GOOGLE_GET_PLACE, USER_IMG_SEND,USER_SEARCH,USER_AVATAR_LOAD,DIALOG_ADD, DIALOG_DELETE, DIALOG_GET_LIST, MESSAGE_ADD, MESSAGE_GET_HISTORY]),
      dateFormatter(date) {
        return moment(date).format('MM-DD-YYYY');
      },
      showDialog(id) {
        if (this.dialogs[id].showDialog) return;
        if (this.isDialogOpened) this.closeRoom();
        this.closeAllDialogs();
        this.dialogs[id].showDialog = true;
        this.isDialogOpened = true;
        this.getHistory(this.dialogs[id]);
        this.openRoom(this.dialogs[id]);
      },
      closeDialog(id) {
        this.dialogs[id].showDialog = false;
        this.isDialogOpened = false;
        this.closeRoom(this.dialogs[id]);
      },
      clearQuery() {
        this.searchFilter.name = null;
        this.applyFilters();
      },
      applyFilters() {
        this.users = [];
        this.queryArr = [];
        if (this.searchFilter.name && this.searchFilter.name.length) {
          this.queryArr.push(this.searchFilter.name);
        } else {
          this.queryArr.push('');
        }
        this.startSearch(this.queryArr);
      },
      startSearch(query, isScrolling) {
        this.USER_SEARCH({query: query, skip: (this.currentPage-1)*this.countPerPageS, limit: this.countPerPageS})
          .then(res=>{
            if (isScrolling) {
              var oldUsers = JSON.parse(JSON.stringify(this.users));
            }
            this.users = JSON.parse(JSON.stringify(res.users));
            this.allSearchCount = res.allSearchCount;
            this.maxPage = parseInt(this.allSearchCount/this.countPerPageS) + ((this.allSearchCount % this.countPerPageS)?1:0)
            if(this.maxPage) {
              if(this.currentPage > this.maxPage) {
                this.currentPage = this.maxPage;
              } 
            }
            this.users.forEach(u => {
              // Обновляем кеш аватарок
              if(!~this.cacheAvatars.findIndex(c=>c.id===u.id)) {
                this.cacheAvatars.push({id: u.id})
              }
            });
            this.cacheAvatars.forEach(c => {
              if(!c.avatar) {
                this.USER_AVATAR_LOAD(c)
                  .then((img)=>{
                    c.avatar = img
                    this.users.filter(u=>u.id===c.id).forEach(u1=>u1.avatar=c.avatar)
                    this.users.push({})
                    this.users.splice(this.users.length-1,1)
                  })
                  .catch((err)=>console.log(err))
              } else {
                this.users.filter(u=>u.id===c.id).forEach(u1=>u1.avatar=c.avatar)
                this.users.push({})
                this.users.splice(this.users.length-1,1)
              }
            });
            if (isScrolling) {
              this.insertArrayAt(this.users, 0, oldUsers);
            }
          })
          .catch((err)=>console.log(err))
      },
      startDialog(user) {
        if (this.isMobileResolution) {
            this.showSearchResults = false;
            this.$scrollTo('#scroll', 500, { container: '#dialogsContainer' });
        }
        this.closeAllDialogs();
        // add dialog only if this new
        var isOldDialog = this.dialogs.find((d) => {
          return d.personId === user.id;
        });
        if (!isOldDialog || (typeof isOldDialog === 'undefined')) {
          this.DIALOG_ADD({
              dialogWithId: user.id,
          }).then((res) => {
              console.log(res);
              this.dialogs.push({
                  id: res.result,
                  showDialog: true, 
                  lastMessage: '',
                  person: user.firstName + ' ' + user.lastName,
                  personId: user.id,
                  newMessage: '',
                  history: []
              });
              this.isDialogOpened = true;
              this.getHistory(this.dialogs[this.dialogs.length-1]);
              this.openRoom(this.dialogs[this.dialogs.length-1]);
              this.loadDialogAvatar();
          }).catch((err)=> {
              console.log(err);
              this.toast.fire({
                  title: '<i class="fa fa-times fa-2x"></i>' + this.$t('hpf_err_unknown')
              });
          });
        } else {
          this.closeAllDialogs();
          this.isDialogOpened = true;
          isOldDialog.showDialog = true;
          this.getHistory(isOldDialog);
          this.openRoom(isOldDialog);
          console.log('Dialog already exist!!!');
        }
      },
      deleteDialog(id) {
        swal.fire({
          title: this.$t('msg_delete_dialogs'),
          text: this.$t('msg_delete_dialogs2'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#FB404B',
          confirmButtonText: this.$t('pr_delete_ok'),
          cancelButtonText: this.$t('pr_delete_cancel'),
          cancelButtonClass: 'profile-delete-cancel'
        }).then((result) => {
          if (result.value) {
            this.isDialogOpened = false;
            this.dialogs[id].showDialog = false;
            this.DIALOG_DELETE({
                id: this.dialogs[id].id,
            }).then(() => {
                this.dialogs.splice(id,1);     
            }).catch((err)=> {
                console.log(err);
                this.toast.fire({
                    title: '<i class="fa fa-times fa-2x"></i>' + this.$t('hpf_err_unknown')
                });
            });
          }
        });
      },
      addToBlackList(id) {
        swal.fire({
          title: this.$t('msg_block_text'),
          text: this.$t('msg_block_desc'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#FB404B',
          confirmButtonText: this.$t('msg_block_yes'),
          cancelButtonText: this.$t('pr_delete_cancel'),
          cancelButtonClass: 'profile-delete-cancel'
        }).then((result) => {
          if (result.value) {
            console.log(id);
          }
        });
      },
      switchSearchResults() {
        this.showSearchResults = !this.showSearchResults;
      },
      onScrollUsersList ({ target: { scrollTop, clientHeight, scrollHeight }}) {
        if (scrollTop + clientHeight >= scrollHeight) {
          this.loadNextUsers()
        }
      },
      loadNextUsers() {
        if (this.currentPage < this.maxPage) {
          this.currentPage++;
          let emptyArr = [];
          this.startSearch(emptyArr, true); 
        }
      },
      insertArrayAt(array, index, arrayToInsert) {
          return Array.prototype.splice.apply(array, [index, 0].concat(arrayToInsert));
      },
      sendMessage(dialog) {
        this.MESSAGE_ADD({
            adressedToId: dialog.personId,
            text: dialog.newMessage
        }).then(() => {
            dialog.newMessage = '';
        }).catch((err)=> {
            console.log(err);
            this.toast.fire({
                title: '<i class="fa fa-times fa-2x"></i>' + this.$t('hpf_err_unknown')
            });
        });
      },
      getHistory(dialog) {
        dialog.history = [];
        this.MESSAGE_GET_HISTORY({
          id: dialog.id
        })
        .then(res=> {
            res.result.forEach(h => {
              dialog.history.push({
                writtenByMe: h.authorId === this.me.id ? true : false, 
                text: h.text,
                date: h.date,
              });
            });
            if (dialog.history[dialog.history.length-1] && (typeof dialog.history[dialog.history.length-1].text !== 'undefined')) {
              dialog.lastMessage = dialog.history[dialog.history.length-1].text;
            } else {
              dialog.lastMessage = ' ... ';
            }
        }).catch(err=> {
          console.log(err);
          this.toast.fire({
              title: '<i class="fa fa-times fa-2x"></i>' + this.$t('hpf_err_unknown')
          });
        });
      },
      closeAllDialogs() {
        // close if any dialog was opened
        this.isDialogOpened = false;
        this.dialogs.forEach(d => {
          d.showDialog = false;
        });
      },
      loadDialogAvatar() {
        this.dialogs.forEach(u => {
          if(!~this.cacheAvatars2.findIndex(c=>c.id===u.personId)) {
            this.cacheAvatars2.push({id: u.personId})
          }
        });
        this.cacheAvatars2.forEach(c => {
          if(!c.avatar) {
            this.USER_AVATAR_LOAD(c)
              .then((img)=>{
                c.avatar = img
                this.dialogs.filter(u=>u.personId===c.id).forEach(u1=>u1.avatar=c.avatar)
                this.dialogs.push({})
                this.dialogs.splice(this.dialogs.length-1,1)
              })
              .catch((err)=>console.log(err))
          } else {
            this.dialogs.filter(u=>u.personId===c.id).forEach(u1=>u1.avatar=c.avatar)
            this.dialogs.push({})
            this.dialogs.splice(this.dialogs.length-1,1)
          }
        });
      },
      openRoom(dialog) {
        const obs = interval(100);
        obs.pipe(takeUntil(obs.pipe(filter(val => {
          if (this.getAccessToken) {
            var token = JSON.parse(JSON.stringify(this.getAccessToken));
            this.dialogUser = {
              name: this.me.firstName || this.me.teamName,
              room: dialog.id,
              originalId: this.me.id,
              token: token
            };
            this.$socket.emit("userJoined", this.dialogUser, data => {
              if (typeof data === "string") {
                console.error(data);
              } else {
                this.dialogUser.id = data.userId;
              }
            });
            return true;
          } else {
            if (val > 300) {
              console.log('time out 30s. for load token')
              return true;
            }
          }
        })))).subscribe(()=>{});
      },
      closeRoom() {
        this.$socket.emit("userLeft", this.dialogUser, () => {
          
        });
      },
      socketSendMessage(dialog) {
        this.$socket.emit(
          "createMessage",
          {
            text: dialog.newMessage,
            id: this.dialogUser.id, //this.$store.state.user.id
            name: this.dialogUser.name,
            room: this.dialogUser.room,
            originalId: this.dialogUser.originalId
          },
          data => {
            if (typeof data === "string") {
              console.error(data);
            } else {
              this.sendMessage(dialog);
            }
          }
        );
      },
    },
  }
</script>

<style scoped>
  .content {
    background-color:#F7F7F8 !important;
    min-height: 100%;
    padding-left: 5px !important;
    padding-right: 5px !important;
    padding-top: 25px !important;
    overflow: hidden;
  }
  
  .card {
      border-radius: 4px;
      background-color: #fff;
      margin-bottom: 30px;
  }
  
  .card {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-clip: border-box;
    border: 1px solid rgba(0, 0, 0, .125);
    border-radius: .25rem
  }

  .card>hr {
      margin-right: 0;
      margin-left: 0
  }

  .card>.list-group:first-child .list-group-item:first-child {
      border-top-left-radius: .25rem;
      border-top-right-radius: .25rem
  }

  .card>.list-group:last-child .list-group-item:last-child {
      border-bottom-right-radius: .25rem;
      border-bottom-left-radius: .25rem
  }

  .card-body {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 1.25rem
  }

  .card .card-body {
    padding: 15px 15px 10px;
  }

  .card .card-header {
    padding: 15px 15px 0;
    background-color: #fff;
    border-bottom: none!important;
  }

  .card-header {
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    background-color: rgba(255, 255, 255, 0.03);
    border-bottom: 1px solid rgba(255, 255, 255, 0.125);
  }

  .form-control::-webkit-input-placeholder {
    color: #6c757d;
    opacity: 1
  }

  .form-control:-ms-input-placeholder,
  .form-control::-ms-input-placeholder {
      color: #6c757d;
      opacity: 1
  }

  .form-control::placeholder {
      color: #6c757d;
      opacity: 1
  }

  .form-control:-moz-placeholder,
  .form-control::-moz-placeholder {
      color: #ddd;
      opacity: 1;
      filter: alpha(opacity=100)
  }

  .form-control::-webkit-input-placeholder {
      color: rgb(207, 207, 207);
      opacity: 1;
      filter: alpha(opacity=100)
  }

  .form-control:-ms-input-placeholder {
      color: #ddd;
      opacity: 1;
      filter: alpha(opacity=100)
  }

  .form-control:focus {
    border-color: rgba(168, 45, 56, 0.7) !important;
  }

  .form-control {
    background-color: #fff;
    border-radius: 4px;
    font-size: .975rem;
    color: #565656;
    padding: 8px 12px;
    height: 40px;
    box-shadow: none;
  }

  .card label {
    font-size: 14px;
    margin-bottom: 5px;
    text-transform: uppercase;
    font-weight: 400;
    color: #828080;
  }

  label {
    display: inline-block;
  }

.card-profile .avatar {
    width: 124px;
    height: 124px;
    border: 5px solid #eee;
    position: relative;
    margin-bottom: 15px;
    background-color: white;
}

.card-profile .avatar.border-gray {
    border-color: #eee;
    border-radius: 100px;
}

.card-profile .title {
    line-height: 24px
}

.card-profile .card-header.no-padding {
    padding: 0
}

.card-profile .card-footer .button-container .btn {
    font-size: 16px
}

.card-profile hr {
    margin: 5px 15px;
    border-top: 1px solid rgb(187, 187, 187) !important;
}

.card .author {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    overflow: hidden;
    margin: 0 auto;
    transition: all .3s linear
}

.card .author i {
    font-size: 14px
}

.card.card-lock .card-header .author {
    width: 100px;
    height: 100px
}

.card-profile .author {
    text-align: center;
    text-transform: none;
    margin-top: -70px
}

.title {
  color: #565656;
}

.card-profile .title {
  line-height: 24px;
}

.author .title {
  color: #565656;
}

.p-title {
  color: #565656;
}

.p-title i {
  position: relative;
  top: 4px;
  font-size: 30px !important;
}

.card .description {
    color: #565656;
}

.card.card-profile .card-body {
  background-color: white !important;
}

h4 {
  font-size: 1.4rem;
}

h4 small, h5 .small, h5 small, h6 .small, h6 small {
    color: #9a9a9a;
    font-weight: 400;
    line-height: 1.5;
}

.small, small {
    font-size: 80%;
}

hr {
    border: 0;
    border-top: 1px solid rgba(0,0,0,.1) !important;
}

.fa-size {
  font-size: 20px;
}

.form-radio {
  font-size: 22px !important;
}

.form-radio span {
  font-size: 14px !important;
  padding-left: 5px;
  margin-bottom: 5px;
}

  input:disabled,
  select:disabled,
  button:disabled {
    color: #bdbdbd !important;
  }

.select-btn {
  margin: 5px;
  background-color: white;
  color: #353535;
  border: 1px solid #ced4da;
}

.select-btn:hover {
  border: 1px solid #026ee2;
  transition: all .5s;
}

.select-btn:active {
  transform: scale(1.1);
  transition: all .3s;
}

.select-text {
  font-size:12px;
  line-height:1;
  margin-top:3px;
  color: #565656;
}

.cover-text {
  padding-right: 5px;
  color: #565656;
}

.card-padding {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.p-title.title-collapse {
  margin-bottom: 0 !important;
  text-align: left;
  padding-left: 5px;
}

.customize-title {
  margin-bottom: 23px;
  padding-left: 5px;
}

div.card.mb-1 {
  border-right: none !important;
  border-left: none !important;
}

.card-body.b-1 {
  box-shadow: inset 0 7px 10px -7px rgba(0,0,0,.14);
  min-height: 100px !important;
}

@media only screen and (max-width: 768px) {
    #first {
        order: 1;
    }
    #second {
        order: 2;
    }
    .content {
      padding-top: 45px !important;
    }
}

.card-header .title.title-header {
  display: inline-block;
}

.msg-header {
    text-transform: uppercase;
    font-size: 18px !important;
    color: #565656 !important;
}
.msg-card-header .fa {
  font-size: 22px;
  position: absolute;
  right: 18px;
  font-weight: 600;
}
.msg-body {
    height: 77vh;
    /* height:100%; */
    overflow-y: auto;
    overflow-x: hidden;
}
.select-body {
    height: 77vh;
}
.msg-card-header {
    padding-bottom: 5px !important;
}
.msg-box {
    height: 80px;
    border-bottom: 1px solid rgba(0, 0, 0, .125);
    border-top: 1px solid transparent;
    position: relative;
}
.msg-box:hover {
    cursor: pointer;
    background-color: #f2f2f2;
}
.msg-delete {
    position: absolute;
    opacity: 0;
    right: 15px;
    top: 10px;
}
.msg-delete:hover .fa {
    color: gray;
    cursor: pointer;
}
.msg-delete .fa {
    color: rgb(170, 170, 170);
    font-size: 16px;
}
.msg-box:hover .msg-delete {
    opacity: 1;
}
.image-avatar {
    width: 65px;
    height: 65px;
    border-radius: 100px;
    border: 1px solid #eee;
    margin-top: 7px;
    margin-left: 6px;
    object-fit: cover;
}
.msg-title {
    color: #565656;
    text-align: left;
    margin-top: 5px;
    font-weight: 500;
    display: block;
}
.msg-old {
    color: #565656;
    background-color: #f2f2f2;
    border-radius: 4px;
    padding: 2px 10px 2px 10px;
    width: 92%;
    margin-top: 3px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.chat-header {
  height: 50px;
  background-color: #f2f2f2;
  border-bottom: 1px solid rgba(0, 0, 0, 0.014);
}
.chat-box {
  border: 1px solid rgba(0, 0, 0, .125);
  height: 100%;
  position: relative;
  border-radius: 0.25rem;
}
.chat-box span > i.fa-angle-left {
  font-size: 35px;
  position: relative;
  top: 6px;
  color: gray;
  padding-right: 8px;
}
.chat-box a > i.fa-circle-o {
  color: gray;
  padding-right: 2px;
  font-size: 10px;
  position: relative;
  top: -2px;
}
.chat-box a > i.fa-circle{
  color: rgb(24, 204, 24);
  padding-right: 2px;
  font-size: 10px;
  position: relative;
  top: -2px;
}
.btn-transparent {
  font-weight: normal;
  margin: 0;
  padding: 0;
  text-transform: uppercase;
  color: #565656;
  display: block;
  cursor: pointer;
}
.btn-transparent:hover {
  color: black !important;
}
.btn-transparent:hover i.fa {
  color: black !important;
}
.chat-box span.back {
  padding-left: 10px;
}
.chat-box a.person {
  text-align: right;
  display: block;
  position: relative;
  top: 12px;
  padding-right: 10px;
  color: #565656;
}
.chat-box a.person:hover {
  text-decoration: underline;
  cursor: pointer;
}
.chat-body {
  padding: 20px;
  height: calc(80% - 50px);
  overflow: auto;
}
.chat-body::-webkit-scrollbar {
  width: 9px
}
.chat-body::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent
}
.chat-body::-webkit-scrollbar-thumb {
    background: lightgray;
    border-radius: 0.25rem;
}
.chat-body::-webkit-scrollbar-thumb:hover {
    background: rgb(192, 192, 192);
}
.chat-box .chat-textarea {
  height: 20%;
  width: 100%;
  position: relative;
  padding: 15px;
  background-color: #f2f2f2;
  border-top: 1px solid rgba(0, 0, 0, 0.014);
}
.chat-box .chat-textarea textarea {
  width: 92%;
  height: 100%;
  border-radius: 0.25rem;
  resize: none;
  border-color: #d6d6d6f2;
  padding: 8px;
  color: #565656;
  border-width: 1px;
}
.chat-box .chat-textarea .btn-send {
  font-size: 33px;
  position: relative;
  bottom: 7px;
  color: gray;
  left: 20px;
}
.chat-box .chat-textarea .btn-send:hover {
  color: black;
  cursor: pointer;
}
.chat-box .chat-body .chat-person {
  background-color: #789dff4f;
  color: black;
  width: 70%;
  border-radius: 8px;
  padding: 10px;
  font-weight: normal;
  font-size: 1rem;
  display: block;
  margin-bottom: 15px;
  float: left;
}
.chat-box .chat-body .chat-author {
  background-color: #ff4b004d;
  color: black;
  width: 70%;
  border-radius: 8px;
  padding: 10px;
  font-weight: normal;
  font-size: 1rem;
  display: block;
  margin-bottom: 15px;
  float: right;
}
.chat-box .chat-body .author-name {
  font-size: 0.7rem;
  font-weight: bold;
  padding-bottom: 5px;
  text-transform: lowercase;
}
.search-result-box::-webkit-scrollbar {
  width: 9px
}
.search-result-box::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent
}
.search-result-box::-webkit-scrollbar-thumb {
    background: lightgray;
    border-radius: 0.25rem;
}
.search-result-box::-webkit-scrollbar-thumb:hover {
    background: rgb(192, 192, 192);
}
.search-result-box {
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100% - 50px);
  position: relative;
}
.search-result-box a.profile-link {
  margin-left: 5px;
}
.search-input {
  margin-bottom: 10px !important;
}
.search-input span {
    position: absolute;
    top: 11px;
    left: 11px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    z-index: 99999;
    color: #565656;
  }
  .search-input input{
    outline: none;
    border-radius: 0.25rem !important;
    padding-right: 75px;
  }
  .search-input .btn-search {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
    background-color: #FB404B !important;
    border-color: #FB404B !important;
    color: #ffffff;
    cursor: pointer;
    text-transform: lowercase;
    padding: 6px 8px !important;
    height: 100%;
    border-radius: 0 0.25rem 0.25rem 0;
  }
  .search-input .btn-search:hover {
    background-color: rgb(253, 36, 50) !important;
  }
  .search-result {
    border-bottom: 1px solid rgba(0, 0, 0, .125);
    padding-bottom: 7px;
    padding-top: 7px;
  }
  .search-result:hover {
    cursor: pointer;
    background-color: #f2f2f2;
  }
  .search-result .img-avatar:hover {
    border: 2px solid lightgray;
  }
  .search-result p {
    margin-bottom: 5px !important;
  }
  .search-result a {
    color: black !important;
  }
  .search-result a:hover {
    color: black !important;
  }
  .search-result span {
    font-size: 1rem !important;
    color: #565656;
    font-weight: 500;
  }
  .search-result .artist-type {
    font-size: 1rem !important;
    color: #565656;
    text-transform: lowercase;
  }
  .img-avatar {
    border-radius: 100px;
    border: 2px solid #eee;
    width: 55px;
    height: 55px;
  }
  .btn-start-dialog {
    font-size: 14px !important;
    padding: 6px;
    position: relative;
    top: 7px;
  }
  .collapsing {
    -webkit-transition: none;
    transition: none;
    display: none;
    -webkit-transition-delay: 0s;
    transition-delay: 0s;
  }
  .msg-no-find {
    margin-top: 50px;
    color: #565656;
    text-align: center;
    font-size: 1rem;
  }
  .msg-no-dialogs {
    text-align: center;
    margin-top: 50px;
    color: #565656;
  }
  
@media(min-width: 401px) {
  .msg-img {
    width: 23%;
  }
  .msg-title-block {
      width: 77%;
  }
}
@media(min-width:768px){
  .msg-img {
    width: 22%;
  }
  .msg-title-block {
      width: 78%;
  }
}
@media(min-width:1200px){
  .msg-img {
    width: 15%;
  }
  .msg-title-block {
      width: 85%;
  }
}
@media(min-width:1600px){
  .msg-img {
    width: 12%;
  }
  .msg-title-block {
      width: 88%;
  }
}
@media(min-width:1900px){
  .msg-img {
    width: 10%;
  }
  .msg-title-block {
      width: 90%;
  }
}

@media(max-width: 400px) {
  .msg-img {
    width: 28%;
  }
  .msg-title-block {
      width: 72%;
  }
}

@media(max-width: 768px) {
  .image-avatar {
    width: 60px;
    height: 60px;
    border-radius: 100px;
    border: 1px solid #eee;
    margin-top: 9px;
    margin-left: 6px;
    object-fit: cover;
  }
  .img-avatar {
    width: 60px;
    height: 60px;
  }
  .chat-box .chat-textarea textarea {
    width: 85%;
  }
  .search-result-box::-webkit-scrollbar {
    width: 0px
  }
  .btn-transparent {
    font-size: 0.9rem;
  }
  .chat-box a.person {
    font-size: 0.9rem;
  }
  .chat-box .chat-body .chat-author {
    width: 85%;
  }
  .chat-box .chat-body .chat-person {
    width: 85%;
  }
  .msg-body-mobile {
    padding: 0 !important;
  }
  /* .chat-box span > i.fa-angle-left {
    font-size: 30px;
  } */
}
</style>

<style>
.fa.fa-ellipsis-v {
  color: gray;
}
.fa.fa-ellipsis-v:hover {
  color: black;
}
</style>


<style scoped>
.messages-page { max-width: 1440px; margin: auto; }
.dialog-list h2 { font-size: 20px; }
.dialog-list .card-body { padding: 0 16px; }
.dialog-list .msg-box { height: auto; min-height: 88px; }
.dialog-list .msg-title-block { min-width: 0; flex: 1; padding-right: 24px; }
.selected-dialog { background: #f4e9eb; border-left: 3px solid #a82d38; }
.msg-body, .msg-body-mobile { height: auto !important; min-height: 420px; }
.chat-box { height: auto; }
.chat-body { height: 48vh !important; min-height: 240px; overflow-y: auto; overflow-x: hidden; padding: 16px; }
.chat-box .chat-body .chat-person { background: #f1eded; overflow-wrap: anywhere; }
.chat-box .chat-body .chat-author { background: #f2dfe2; overflow-wrap: anywhere; }
.chat-box .chat-textarea { height: auto; display: flex; align-items: center; gap: 12px; background: white; }
.chat-box .chat-textarea textarea { flex: 1; min-width: 0; height: 84px; width: auto; }
.chat-box .chat-textarea .btn-send { position: static; border: 0; background: transparent; color: #a82d38; padding: 4px; }
.chat-header { height: auto; min-height: 54px; background: #f7f3f4; }
.chat-header .back { background: transparent; border: 0; font: inherit; padding: 12px 8px; }
.chat-header a.person { overflow-wrap: anywhere; }
.chat-header .back i { padding-right: 6px; }
.msg-delete { opacity: 1; }
@media(max-width: 767px) {
  .messages-page { padding-top: 16px !important; }
  .chat-body { height: 45vh !important; }
  .card .card-body.msg-body { padding: 8px; }
  .chat-box .chat-body .chat-person, .chat-box .chat-body .chat-author { width: 88%; }
  .chat-box .chat-textarea { padding: 10px; }
}
</style>
